import { IconBase, IconProps, IconWeight } from '@phosphor-icons/react';
import { forwardRef, ReactElement } from 'react';

import { IconType } from './IconTypes';

const Icon: IconType = ({ color }) => (
  <>
    <g clipPath="url(#clip0_2971_22673)">
      <mask
        id="mask0_2971_22673"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2971_22673)">
        <path
          d="M14.2414 22V20.7055C16.0374 20.7055 17.5639 20.0775 18.8211 18.8216C20.0783 17.5656 20.7069 16.0361 20.7069 14.233H22C22 15.3118 21.7953 16.3222 21.3858 17.2643C20.9763 18.2064 20.4231 19.0262 19.7263 19.7238C19.0295 20.4214 18.2105 20.9752 17.2694 21.3851C16.3283 21.795 15.319 22 14.2414 22ZM14.2414 19.411V18.1165C15.2328 18.1165 16.1272 17.7174 16.9246 16.9191C17.722 16.1208 18.1207 15.2255 18.1207 14.233H19.4138C19.4138 15.5994 18.893 16.804 17.8513 17.8468C16.8096 18.8896 15.6063 19.411 14.2414 19.411ZM6.9569 21.6332C6.78922 21.6332 6.62162 21.6009 6.45409 21.5361C6.28642 21.4714 6.14512 21.3815 6.03017 21.2665L2.36638 17.5987C2.25144 17.4836 2.16164 17.343 2.09698 17.1767C2.03233 17.0106 2 16.8444 2 16.6781C2 16.5008 2.03182 16.3338 2.09547 16.1773C2.15927 16.021 2.24957 15.8835 2.36638 15.7648L5.62069 12.507C5.86494 12.2625 6.17026 12.1402 6.53664 12.1402C6.90302 12.1402 7.20833 12.2625 7.45259 12.507L8.8319 13.8878L9.62931 13.0895L8.25 11.7087C8.00575 11.4598 7.88362 11.1566 7.88362 10.7991C7.88362 10.4419 8.00575 10.141 8.25 9.89644L9.86638 8.27832C10.1161 8.0338 10.4228 7.91154 10.7864 7.91154C11.1501 7.91154 11.454 8.0338 11.6983 8.27832L13.0776 9.65912L13.875 8.86084L12.4957 7.48004C12.2514 7.23006 12.1293 6.92305 12.1293 6.55901C12.1293 6.19497 12.2514 5.89069 12.4957 5.64617L15.75 2.38835C15.8773 2.2589 16.0205 2.16181 16.1795 2.09709C16.3386 2.03236 16.5043 2 16.6767 2C16.8491 2 17.0144 2.02877 17.1724 2.0863C17.3305 2.14383 17.4741 2.23732 17.6034 2.36677L21.2672 6.03452C21.3947 6.15707 21.4876 6.2991 21.5459 6.46063C21.6044 6.62229 21.6336 6.79223 21.6336 6.97044C21.6336 7.13758 21.5977 7.30385 21.5259 7.46926C21.454 7.63466 21.3606 7.7749 21.2457 7.88997L17.9914 11.1478C17.6609 11.4786 17.3556 11.644 17.0754 11.644C16.7953 11.644 16.4899 11.4786 16.1595 11.1478L14.7802 9.76699L13.9828 10.5653L15.3621 11.9461C15.6063 12.196 15.7249 12.5031 15.7177 12.8671C15.7105 13.2311 15.5848 13.5354 15.3405 13.7799L13.7457 15.3765C13.496 15.621 13.1893 15.7433 12.8256 15.7433C12.462 15.7433 12.158 15.621 11.9138 15.3765L10.5345 13.9957L9.73707 14.794L11.1164 16.1748C11.3606 16.4193 11.4828 16.7249 11.4828 17.0917C11.4828 17.4585 11.3606 17.7641 11.1164 18.0086L7.86207 21.2665C7.74353 21.3834 7.60618 21.4738 7.45 21.5376C7.29368 21.6014 7.12931 21.6332 6.9569 21.6332ZM6.9569 20.3603L8.12069 19.1953L4.4569 15.5275L3.2931 16.6926L6.9569 20.3603ZM9.04741 18.2675L10.2112 17.1025L6.54741 13.4347L5.38362 14.5998L9.04741 18.2675ZM17.0862 10.2201L18.25 9.05502L14.5862 5.38727L13.4224 6.55232L17.0862 10.2201ZM19.1767 8.12729L20.3405 6.96224L16.6767 3.2945L15.5129 4.45955L19.1767 8.12729Z"
          fill={color}
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2971_22673">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

const buildWeights = (color: string) =>
  new Map<IconWeight, ReactElement>([
    ['bold', <Icon color={color} strokeWidth={24} />],
    ['duotone', <Icon color={color} strokeWidth={16} opacity={0.2} />],
    ['fill', <Icon color={color} strokeWidth={16} opacity={1} />],
    ['light', <Icon color={color} strokeWidth={12} />],
    ['thin', <Icon color={color} strokeWidth={8} />],
    ['regular', <Icon color={color} strokeWidth={8} />],
  ]);

export const Satmode = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <IconBase
    ref={ref}
    {...props}
    weights={buildWeights(props.color ?? 'currentColor')}
    viewBox="0 0 24 24"
    fill="none"
  />
));

Satmode.displayName = 'Satellite mode';
